var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:shopping-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.3333 8.50065H22.6667C22.6667 4.76732 19.7333 1.83398 16 1.83398C12.2667 1.83398 9.33333 4.76732 9.33333 8.50065H6.66667C5.2 8.50065 4 9.70065 4 11.1673V27.1673C4 28.634 5.2 29.834 6.66667 29.834H25.3333C26.8 29.834 28 28.634 28 27.1673V11.1673C28 9.70065 26.8 8.50065 25.3333 8.50065ZM16 4.50065C18.2667 4.50065 20 6.23398 20 8.50065H12C12 6.23398 13.7333 4.50065 16 4.50065ZM25.3333 27.1673H6.66667V11.1673H25.3333V27.1673ZM16 16.5007C13.7333 16.5007 12 14.7673 12 12.5007H9.33333C9.33333 16.234 12.2667 19.1673 16 19.1673C19.7333 19.1673 22.6667 16.234 22.6667 12.5007H20C20 14.7673 18.2667 16.5007 16 16.5007Z",
    fill: "#737791"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarProducts);
export default __webpack_public_path__ + "static/media/sidebar_products.4be457e14143781b76c1f59465da86ff.svg";
export { ForwardRef as ReactComponent };